<div class="svg-highlight" [ngClass]="{'ready': isReady}" #mainEl [ngSwitch]="svgType" aria-hidden="true">
  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 334.03 354.23" *ngSwitchCase="0">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m56.69,104.42c68.26-12.1,135.84-28.04,202.31-47.72-5.26,8.49-12.33,15.79-20.39,21.68-10.98,8.02-23.64,13.39-36.3,18.35-44.43,17.39-90.38,30.53-136.25,43.64,21.59,3.97,43.72,3.59,65.66,2.73,48.63-1.93,97.13-6.19,145.62-10.45-30.84,15.84-58.8,37.02-90.31,51.47-21.38,9.8-44.07,16.36-66.67,22.86-17.29,4.98-34.59,9.94-51.89,14.9,69.08,1.48,138.22,0,207.18-4.44-57.48,38.3-127.88,51.18-190.6,80.11"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412.65 413.93" *ngSwitchCase="1">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m56.69,111.45c17.34,83.62,41.23,165.88,71.38,245.78-8.64-41.79-11.34-84.56-13.02-127.19-1.8-45.72-2.46-91.48-1.97-137.23,27.92,36.68,51.95,76.14,75.93,115.51,19.19,31.52,38.39,63.03,57.58,94.55-10.73-82.01-5.86-166.43-27.81-246.18,13.71,33.01,30.84,64.47,47.94,95.86,25.47,46.76,51.47,94.23,89.23,131.77"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 478.18 329.72" *ngSwitchCase="2">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m56.69,118.96c5.4,17.85,15.36,33.91,24.52,50.16,18.68,33.15,34.39,67.97,46.86,103.92,3.04-.12,4.51-3.71,5.21-6.67,12.67-53.78,10.76-109.79,8.77-165.01,41.46,51.79,82.91,103.58,124.37,155.38-7.41-66.36,7.65-133.36,4.04-200.04,22.99,14.09,45.16,29.54,66.34,46.23,8.28,6.52,16.47,13.3,22.96,21.6,6.64,8.5,11.3,18.33,16.86,27.58,11.69,19.44,27.39,36.28,44.86,50.75"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310.98 334.58" *ngSwitchCase="3">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m77.42,57.84c22.3-.97,44.63-1.32,66.95-1.07,10.2.12,20.61.4,30.18,3.94,13.04,4.83,23.2,15.23,31.9,26.08,11.32,14.14,20.95,29.58,29.31,45.64,8.83,16.95,16.36,34.97,18.16,54,1.79,19.03-2.77,39.31-15.63,53.44-16.79,18.45-43.43,23.04-67.16,30.76-11.22,3.65-22.65,8.28-34.39,7.05-6.31-.66-12.33-3.02-17.96-5.95-18.38-9.58-33.04-25.48-43.04-43.63s-15.53-38.51-18.31-59.05c-.6-4.47-1.08-9.01-.42-13.47.79-5.39,3.2-10.39,5.65-15.25,4.87-9.67,10.38-19.54,19.3-25.67,5.68-3.89,12.4-6.01,19.16-7.32,32.2-6.23,66.93,5.76,89.73,29.34,22.8,23.58,33.59,57.77,30.26,90.4-.12,1.14-.27,2.34-.95,3.27-.77,1.06-2.08,1.56-3.31,2-12.41,4.47-24.97,8.52-37.64,12.16-8.61,2.47-17.62,4.76-26.44,3.17-6.01-1.08-11.58-3.93-16.68-7.29-18.81-12.4-32.32-32.57-36.62-54.69-.9-4.63-1.37-9.63.68-13.87,2.88-5.97,10.14-8.79,16.76-8.41s12.79,3.31,18.76,6.2c13.39,6.47,26.78,12.93,40.17,19.4"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 398.5 439.01" *ngSwitchCase="4">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m329.56,56.69c-50.51,7.71-99.55,23.81-150.3,29.8-16.94,2-34.06,2.87-50.73,6.52-24.49,5.36-47.38,16.59-71.84,22.05,8.38,31.25,5.11,64.25,6.52,96.57,2.49,57.29,19.84,113.34,20.24,170.68,56.15-4.69,112.33-9.38,168.14-17.1,30.72-4.25,61.64-9.51,90.21-21.57-10.89-76.54-21.81-153.41-21.31-230.72-70.85-3.35-142.14,2.87-211.34,18.44-1.6.36-3.32.79-4.39,2.04-1.36,1.58-1.24,3.91-1.03,5.98,1.24,12.69,2.74,25.37,3.05,38.12,1.09,44.7-12.39,88.51-14.84,133.15-.32,5.74-.1,12.34,4.29,16.05,3.17,2.68,7.64,3.05,11.79,3.27,63.69,3.46,127.56,3.54,191.25.23,5.51-55.15-.59-110.72-6.67-165.81-35.25-6.9-72.07-5.58-106.73,3.83-2.4,27.08-4.81,54.16-7.21,81.25-1.28,14.4-2.52,29.22,1.68,43.06"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 378.26 386.78" *ngSwitchCase="5">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m99.13,330.09c-25.7-77.51-25.62-161.04-42.43-240.95,45.29,56.82,63.35,130.64,102.52,191.85.93-65.06,1.87-130.13,2.8-195.19,14.9,61.39,23.98,124.05,38.12,185.62,2.33,10.15,5.3,21.06,13.54,27.42,16.18-51.41,15.65-106.63,9.92-160.22-2.91-27.25-7.12-54.74-3.59-81.91,29.82,39.09,39.77,89.72,64.17,132.4,10.69,18.7,24.06,35.71,37.38,52.64"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 369.99 453.5" *ngSwitchCase="6">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m143.32,56.69c-5.62,16.84-6.37,34.85-7.39,52.57-4.47,77.95-15.65,157.59-52.93,226.19-10.66,19.62-23.64,38.93-26.3,61.1,39.61-38.52,64.37-89.44,87.32-139.7,25.3-55.4,49.35-111.37,72.15-167.85,4.89,28.57-3.46,57.55-11.23,85.47-20.27,72.8-37.29,146.92-42.17,222.34,58.24-93.05,92.38-199.55,150.55-292.64"/>
    </g>
  </svg>

  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386.94 354.09" *ngSwitchCase="7">
    <defs>
      <style>
        .cls-1 {
          fill: none;
          stroke: #231f20;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 113.39px;
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="m56.69,56.69c71.43,46.7,153.73,76.66,238.47,86.81-66.66,24.34-137.01,38.54-207.89,41.95,9.66,5.63,20.79,8.11,31.78,10.16,58.68,10.98,118.71,12.11,178.4,13.21-30.22,9.19-60.49,18.4-91.38,24.99-14.37,3.06-28.89,5.57-42.91,9.94-14.01,4.37-27.4,10.57-40.26,17.65-18.56,10.22-36.09,22.3-52.25,36,69.79-2.73,140.35,3.79,209.07-8.68,16.74-3.04,34.07-7.18,50.52-2.84"/>
    </g>
  </svg>

</div>
